import BasicLayout from "./BasicLayout.vue";
import SidebarLayout from "./SidebarLayout.vue";

const layout = { BasicLayout, SidebarLayout }

export type layoutType = keyof typeof layout

export default layout
